import { Dictionary } from "../localization/dictionary";
import elementService from "@/common/ElementService";

export default class CustomerProfileOrdersPageService {
    public init(): void {
        this.initShowAllButton();
    }

    private initShowAllButton(): void {
        const showAllOrdersButton = document.querySelector<HTMLAnchorElement>(".js-show-all-orders");

        if (showAllOrdersButton === null) {
            return;
        }

        showAllOrdersButton.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();
            this.showAllOrders(showAllOrdersButton);
        });
    }

    private showAllOrders(showAllOrdersButton: HTMLAnchorElement): void {
        showAllOrdersButton.classList.add("hidden");

        for (const orderTableRow of document.querySelectorAll<HTMLTableRowElement>("#js-order-table tr")) {
            orderTableRow.classList.remove("hidden");
        }

        const orderListHeading = elementService.querySelector<HTMLHeadingElement>(".js-order-list-heading");

        while (orderListHeading.hasChildNodes()) {
            orderListHeading.lastChild?.remove();
        }

        const icon = document.createElement("i");
        icon.classList.add("fas", "fa-file-alt");

        const title = document.createTextNode(Dictionary.Basic.MyOrders);

        orderListHeading.appendChild(icon);
        orderListHeading.appendChild(title);
    }
}
